import { baseApi } from './baseApi';
import {
  Quotation,
  CreateQuotationRequest,
  UpdateQuotationRequest,
} from '../types/inventory';

export const quotationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getQuotations: builder.query<Quotation[], void>({
      query: () => '/quotations',
      providesTags: ['Quotation'],
    }),
    getQuotation: builder.query<Quotation, string>({
      query: (id) => `/quotations/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'Quotation', id }],
    }),
    createQuotation: builder.mutation<Quotation, CreateQuotationRequest>({
      query: (data) => ({ url: '/quotations', method: 'POST', body: data }),
      invalidatesTags: ['Quotation'],
    }),
    updateQuotation: builder.mutation<Quotation, { id: string; data: UpdateQuotationRequest }>({
      query: ({ id, data }) => ({ url: `/quotations/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['Quotation'],
    }),
    deleteQuotation: builder.mutation<void, string>({
      query: (id) => ({ url: `/quotations/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Quotation'],
    }),
    updateQuotationStatus: builder.mutation<Quotation, { id: string; status: string }>({
      query: ({ id, status }) => ({ url: `/quotations/${id}/status`, method: 'PATCH', body: { status } }),
      invalidatesTags: ['Quotation'],
    }),
    getQuotationPdf: builder.query<Blob, string>({
      query: (id) => ({
        url: `/quotations/${id}/pdf`,
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetQuotationsQuery,
  useGetQuotationQuery,
  useCreateQuotationMutation,
  useUpdateQuotationMutation,
  useDeleteQuotationMutation,
  useUpdateQuotationStatusMutation,
  useLazyGetQuotationPdfQuery,
} = quotationsApi;
